module.exports = __webpack_public_path__ + "img/pnu_main0.172d2640.jpg";